// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__t-oQ4","no-padding":"Panel_no-padding__3vESS","wide":"Panel_wide__4M3OL","no-border":"Panel_no-border__2c18N","for-message":"Panel_for-message__3i6uG"};